import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import { UserAgreementService } from '../services/user-agreement';
import * as fromRoot from '../reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class UserAgreementGuard implements CanActivate {
  constructor(private router: Router, private store: Store<fromRoot.State>) {}
  canActivate(route: ActivatedRouteSnapshot) {

    return this.store.select(fromRoot.getHasAcceptedAgreement).map(acc => {
      if (!acc) {
        this.router.navigate(['/agreement']);
      }
      return acc;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/guards/user-agreement.ts